import { getTenantSubdomainContext } from './tenantHost';

export type ClubHostMode = 'path' | 'subdomain';

export function getClubHostMode(hostname?: string): ClubHostMode {
  return getTenantSubdomainContext(hostname).mode;
}
